import api from "../utils/API";

const getAllTypesSocieteForSelect = () => {
  return api.get(`/societemanagement/typesocieteforselect/list`);
};

export {getAllTypesSocieteForSelect};
